export const ONBOARDING_STATUSES = [
  "insurer_review",
  "csv_pending",
  "docs_pending",
  "signature_pending",
  "ops_review",
  "it_review",
  "legalnote_pending",
  "payment_validation_pending",
  "ready_to_send",
] as const;

export const HISTORICAL_STATUSES = ["complete", "canceled", "claim"] as const;

export type OnboardingStatus = (typeof ONBOARDING_STATUSES)[number];
export type HistoricalStatus = (typeof HISTORICAL_STATUSES)[number];
export type LeadStatus = OnboardingStatus | HistoricalStatus;

export type Trait = {
  trait: "DEATH" | "DISABILITY" | "MALATTIA_TERMINALE" | string;
  capital: number;
};

export type OnboardingRow = {
  leadId: number;
  leadUlid: string;
  brokerName: string;
  customer: string;
  email: string;
  dni: string | null;
  policyCount: number;
  relatedLeadIds: number[];
  policyNumber: string;
  status: LeadStatus;
  traits: Trait[];
  purchaseDate: string;
  effectDate: string | null;

  carrier: string;
  medor: string | null;
  capital: number;
  annualPrice: number;
  coverage: "basic" | "premium" | "multi" | string;
  signatureDate: string | null;
  renewalDate: string | null;
  cancellationDate: string | null;
  cancellationReason: string | null;
  cancellationType: string | null;
  cancellationRequestDate: string | null;
  carrierCancellDate: string | null;
  promoName: string | null;
  promoId: string | null;
  stripeCustomerId: string | null;
  signatureLink: string | null;
  frequency: "MONTHLY" | "YEARLY";
  paymentMethod: "CREDIT_CARD" | "SEPA";
  last4Card: string | null;
  expCard: string | null;
  taxConsorcio: number | null;
  taxFallecimiento: number | null;
  taxIpa: number | null;
  memberPhone: string | null;
  observations: string | null;
  hubspotTicket: string | null;
  salesChannel: string | null;
  advisor: string | null;
  partner: string | null;
  previousUnpaidPolicy: string | null;
  birthdate: string | null;
  gender: string | null;
  prp: string | null;
  prpDescription: string | null;
  pendingCancellationRequestId: string | null;
  pendingCancellationRequestStatus: string | null;
};
